var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWalleticon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8516 16.1944H21.4538C19.4719 16.1932 17.8655 14.5879 17.8643 12.606C17.8643 10.6241 19.4719 9.01885 21.4538 9.01764H26.8516",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0654 12.5234H21.6494",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32989 1H19.8545C23.7187 1 26.8513 4.13268 26.8513 7.99688V17.5663C26.8513 21.4305 23.7187 24.5631 19.8545 24.5631H8.32989C4.46569 24.5631 1.33301 21.4305 1.33301 17.5663V7.99688C1.33301 4.13268 4.46569 1 8.32989 1Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38098 7.05066H14.5796",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 26,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWalleticon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Walleticon.b9cc1bf0.svg";
export { ForwardRef as ReactComponent };